import React from 'react';
import ReactDOM from 'react-dom';
import SegmentedControl from 'polyphony/components/generic/segmentedcontrol';
import {safeCall} from 'polyphony/util';
import {useStateWithCallback} from 'polyphony/hooks';

const PostArchiveControl = ({shouldOverride: _shouldOverride,
                             keepFeaturedMedia: _keepFeaturedMedia,
                             keepTitle: _keepTitle,

                             postQuery: _postQuery,
                             postType: _postType,
                             taxonomy: _taxonomy,
                             taxonomyQuery: _taxonomyQuery,

                             option: _option,

                             onShouldOverrideChange, onKeepFeaturedMediaChange,
                             onKeepTitleChange,

                             onOptionChange: _onOptionChange,
                             onPostTypeChange, onPostQueryChange,
                             onTaxonomyChange, onTermQueryChange
}) => {
    const [shouldOverride, setShouldOverride] = useStateWithCallback(_shouldOverride, onShouldOverrideChange);
    const toggleShouldOverride = e => setShouldOverride(e.target.checked);

    const [keepFeaturedMedia, setKeepFeaturedMedia] = useStateWithCallback(_keepFeaturedMedia, onKeepFeaturedMediaChange);
    const toggleKeepFeaturedMedia = e => setKeepFeaturedMedia(e.target.checked);

    const [keepTitle, setKeepTitle] = useStateWithCallback(_keepTitle, onKeepTitleChange);
    const toggleKeepTitle = e => setKeepTitle(e.target.checked);

    const [postQuery, setPostQuery] = useStateWithCallback(_postQuery, onPostQueryChange);
    const [postType, setPostType] = useStateWithCallback(_postType, onPostTypeChange);
    const [taxonomy, setTaxonomy] = useStateWithCallback(_taxonomy, onTaxonomyChange);
    const [taxonomyQuery, setTaxonomyQuery] = useStateWithCallback(_taxonomyQuery, onTermQueryChange);

    const [option, setOption] = useStateWithCallback(_option || 'postType', v => {
        // FIXME: double check; do we need to set these things again?
        if (v === 'postType')           safeCall(onPostTypeChange, postType);
        else if (v === 'postQuery')     safeCall(onPostQueryChange, postQuery);
        else if (v === 'taxonomy')      safeCall(onTaxonomyChange, taxonomy);
        else if (v === 'taxonomyQuery') safeCall(onTermQueryChange, taxonomyQuery);
        if (_onOptionChange) {
            _onOptionChange(v);
        }
    });

    const onInputChange = e => {
        let value = e.target.value;
        if (option === 'postType')           setPostType(value);
        else if (option === 'postQuery')     setPostQuery(value);
        else if (option === 'taxonomy')      setTaxonomy(value);
        else if (option === 'taxonomyQuery') setTaxonomyQuery(value);
    };

    const valueForOption = (() => {
        if (option === 'postType')           return postType;
        else if (option === 'postQuery')     return postQuery;
        else if (option === 'taxonomy')      return taxonomy;
        else if (option === 'taxonomyQuery') return taxonomyQuery;
        return undefined;
    })();

    return (
        <>
            <label style={{margin: "20px 0", display: "block"}}>
                <input type="checkbox"
                       onClick={toggleShouldOverride}
                       checked={shouldOverride} />
                Override with Archive?
            </label>
            {shouldOverride &&
            <>
                <label style={{margin: "20px 0", display: "block"}}>
                    <input type="checkbox"
                           onClick={toggleKeepFeaturedMedia}
                           checked={keepFeaturedMedia} />
                    Keep Featured Media?
                </label>
                <label style={{margin: "20px 0", display: "block"}}>
                    <input type="checkbox"
                           onClick={toggleKeepTitle}
                           checked={keepTitle} />
                    Keep Title?
                </label>
                <SegmentedControl defaultValue={option} color='gray' onChange={setOption}
                                  style={{height: 44, margin: "20px 0", borderRadius: 5,
                                          color: "white", overflow: "hidden"}}>
                    <SegmentedControl.Option title="Post Type" value="postType" />
                    <SegmentedControl.Option title="Post Query" value="postQuery" />
                    <SegmentedControl.Option title="Taxonomy" value="taxonomy" />
                    <SegmentedControl.Option title="Tax Query" value="taxonomyQuery" />
                </SegmentedControl>
                <input type="text" value={valueForOption} onChange={onInputChange} style={{width: '100%'}} />
            </>}
        </>
    );
};

PostArchiveControl.defaultProps = {
    option: 'postType'
};

PostArchiveControl.renderIn = (container, props) =>
    ReactDOM.render(<PostArchiveControl {...props} />, container);

export default PostArchiveControl;

